import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { OT_COMPETENCY_ITEMS } from './otConstants';

const OtCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="OT"
            title="OT CLINICAL COMPETENCY ASSESSMENT"
            items={OT_COMPETENCY_ITEMS}
            totalPages={5}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default OtCompetency;
